import * as React from 'react';
import {
    DataGrid, GridApi, GridCellParams, GridCellValue,
    GridColumns,
    gridPageCountSelector,
    gridPageSelector, gridPageSizeSelector, GridToolbar, GridToolbarContainer, GridToolbarExport,
    useGridApiContext,
    useGridSelector,
} from "@mui/x-data-grid";
import {Box, Button, Grid, Pagination, styled, Typography} from "@mui/material";
import {useDemoData} from "@mui/x-data-grid-generator";
import {Dispatch, SetStateAction, useEffect, useState} from "react";
import {escapeRegExp} from "@mui/x-data-grid/utils/utils";
import Skeleton from "@mui/material/Skeleton";
import {Icon} from "@iconify/react";
import {CurrentUser} from "../../pages/Users";
import services from "../../services";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/store";
import RmpServices from "../../services";
import {setAxiosToken} from "../../http-common";
import {initializeRole, initializeToken, initializeUser,initializeUrl} from "../../app/features/Auth";
import {RoutesList} from "../../Modules/RoutesList";
import {useNavigate} from "react-router-dom";




function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    const perPage = useGridSelector(apiRef,gridPageSizeSelector)

    return (
        <>
            {
                pageCount>0 ?
                    <Grid container justifyContent={"space-between"} alignItems={"center"}>
                        <Grid item>
                            <p>{1} - {perPage} of {pageCount}</p>
                        </Grid>

                        <Grid item>
                            <Pagination
                                count={pageCount}
                                page={page + 1}
                                shape="rounded"

                                sx={{
                                    background:"#FFFFFF",
                                }}
                                onChange={(event, value) => apiRef.current.setPage(value - 1)}
                            />
                        </Grid>
                    </Grid>
                    :
                    ''
            }
        </>
    )
}


function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}

interface DataTable{
    showFooter  : boolean,
    perPage? : number,
    data : any,
    duration? : string,
    height  : number,
    skeleton : boolean,
    setCurrentUser ? : Dispatch<SetStateAction<CurrentUser>>
    setAddViewDevicesModel ? :Dispatch<SetStateAction<boolean>>,
    setAddDeviceModel ? : Dispatch<SetStateAction<boolean>>,
    hideActionsColumn ? : boolean
}

const  ClientDataTable = ({
                              showFooter ,
                              perPage ,
                              data,
                              duration,
                              height,
                              skeleton,
                              hideActionsColumn = false
} : DataTable) => {


    const dispatch = useDispatch()
    const navigate = useNavigate()


    const columns : GridColumns = [
        {field: "id",headerName: "Serial No.", minWidth: 110, flex: 1,align: 'center',headerAlign: 'center',hide:true},
        {field: "name", headerName: "name", minWidth: 100, flex: 1,align: 'center',headerAlign: 'center'},
        {field: "logo", headerName: "logo", minWidth: 100, flex: 1,align: 'center',headerAlign: 'center'},
        {
            field: 'action',
            headerName: 'Access',
            hide:hideActionsColumn,
            minWidth: 50, flex: 1, headerAlign: 'center', align: "center",
            sortable: false,
            renderCell: (params) => {
                const onAccess = (e: any) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellValue> = {};

                    api
                        .getAllColumns()
                        .filter((c) => c.field !== '__check__' && !!c)
                        .forEach(
                            (c) => (thisRow[c.field] = params.getValue(params.id, c.field)),
                        );

                    // @ts-ignore
                    let url = data.filter(d=>d.id === thisRow.id)[0].url

                    dispatch(initializeUrl(url))

                    services.login({email:'superAdmin@gmail.com',password:'qwerty'})
                        .then(response=>{

                                setAxiosToken(response.data.token)
                                let role = response.data.role
                                //
                                localStorage.setItem("user_role",role)
                                localStorage.setItem("token",response.data.token)
                                localStorage.setItem("user",JSON.stringify(response.data.user))
                                //
                                dispatch(initializeToken(response.data.token))
                                dispatch(initializeRole(role))
                                dispatch(initializeUser(response.data.user))

                            navigate(RoutesList.UsersList.path)

                        })
                        .catch(error=>{

                        })


                };

                return (
                    <>
                        <Icon onClick={onAccess} color={"#568187"}
                              fontSize={"24px"}
                              icon="academicons:open-access-square"
                              cursor={"pointer"}/>
                    </>
                );
            }
        }
    ];

    return (

        <>
            <DataGrid
                autoHeight={true}
                rows={data}
                columns={columns}
                pageSize={perPage?perPage:6}
                loading={skeleton}
                components={{
                    Pagination: CustomPagination,
                    NoRowsOverlay:CustomNoRowsOverlay,
                    Toolbar : height!==400?CustomToolbar:null
                }}
            />
        </>
    );
}

const StyledGridOverlay = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    '& .ant-empty-img-1': {
        fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
    },
    '& .ant-empty-img-2': {
        fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
    },
    '& .ant-empty-img-3': {
        fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
    },
    '& .ant-empty-img-4': {
        fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
    },
    '& .ant-empty-img-5': {
        fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
        fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
    },
}));


function CustomNoRowsOverlay() {
    return (
        <StyledGridOverlay>
            <svg
                width="120"
                height="100"
                viewBox="0 0 184 152"
                aria-hidden
                focusable="false"
            >
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(24 31.67)">
                        <ellipse
                            className="ant-empty-img-5"
                            cx="67.797"
                            cy="106.89"
                            rx="67.797"
                            ry="12.668"
                        />
                        <path
                            className="ant-empty-img-1"
                            d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                        />
                        <path
                            className="ant-empty-img-2"
                            d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                        />
                        <path
                            className="ant-empty-img-3"
                            d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                        />
                    </g>
                    <path
                        className="ant-empty-img-3"
                        d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                    />
                    <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
                        <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
                        <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
                    </g>
                </g>
            </svg>
            <Box sx={{ mt: 1 }}>No Rows</Box>
        </StyledGridOverlay>
    );
}

export const AllClients = () =>{

    const [clients,setClients] = useState([])

    useEffect(()=>{
        services.GetAllClients()
            .then(c=>{
                setClients(c.data.clients)
            })
    },[])

    return(

        <div>
            <Typography
                fontSize={32}
                fontWeight={700}
                color="#081735"
            >
                All Clients
            </Typography>
            <ClientDataTable
                data={clients}
                skeleton={false}
                height={400}
                showFooter={true}
            />
        </div>
    )
}